import { useEffect, useRef, useState } from "react";
import ProgressMap from "../../../lms-shared/ProgressMap/ProgressMap";
import classes from './Dashboard.module.css'
import Bunner from './Banner'
import QuickApproach from './QuickApproach'
import MessageArea from './MessageArea'
import { useDispatch, useSelector } from 'react-redux';
import useClickOutside from '../../../../hooks/useClickOutside';
import HeaderActionBar from "../HeaderActionBar/HeaderActionBar";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { fetchTopicsData } from "../../../../store/topic-actions";
import { onKeyDown } from "../../../../service";

const Dashboard = () => {

    const [showMessagesPopup, setShowMessagesPopup] = useState()
    const [showQuickApproachPopup, setShowQuickApproachPopup] = useState()
    const { texts, direction } = useSelector(state => state.translate);
    const [messagePopup, setMessagePopup] = useState()
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const popupRef = useRef(null);
    const { studyGroupId } = useParams()
    const popupRefQuickApproach = useRef(null);
    const { lessonByTopic, studyGroup } = useSelector(state => state.topics);
    const uiData = useSelector((state) => state.general.uiData);
    const { logo, homeUrl } = useSelector((state) => state.application);

    useClickOutside(popupRef, () => {
        setShowMessagesPopup(false)
    });

    useClickOutside(popupRefQuickApproach, () => {
        setShowQuickApproachPopup(false)
    });

    const handleShowLessonViewer = (id) => {
        navigate(`${homeUrl}/${studyGroupId}/lesson/${id}`)
    }
    return (
        <>
            <div className={`${classes[direction]} ${classes.HomePage}`}>
                <div className={`${classes.RoboticaLogo} ${classes.Logo}`}
                    style={{ backgroundImage: `url(${logo})` }}
                    onClick={() => navigate(`${homeUrl}`)}
                    tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => navigate(`${homeUrl}`))}>
                </div>
                <HeaderActionBar />
                <div className={classes.HomePageContainer}>
                    {studyGroup && lessonByTopic && <div className={classes.Map}>
                        <h2 className={classes.DHader}>
                            <NavLink to={`${homeUrl}`}>
                                <div className={classes.BackImg}></div>
                            </NavLink>
                            <div className={classes.CourseNameMap}><span className={classes.MyLessonsText}>{studyGroup.courseName} | </span>{studyGroup.name}</div>
                        </h2>
                        <div className={classes.DProgressMap}>
                            <ProgressMap aiCourse={uiData.aiCourses?.list?.includes(studyGroup.courseId)} markUserPlace={true} studyGroupId={studyGroup.id} topicsList={lessonByTopic} handleShowLessonViewer={handleShowLessonViewer} setMessagePopup={setMessagePopup} />
                        </div>
                    </div>}

                    <div className={classes.RightSideContainer}>
                        <div className={classes.MsgAndBunnerContainer}>
                            <Bunner></Bunner>
                            <div ref={popupRef}>
                                {studyGroup && <MessageArea studyGroupId={studyGroup.id} setShowMessagesPopup={setShowMessagesPopup} showMessagesPopup={showMessagesPopup} setShowQuickApproachPopup={setShowQuickApproachPopup} />}
                            </div>
                        </div>
                        <div ref={popupRefQuickApproach}>
                            {studyGroup && <QuickApproach setShowQuickApproachPopup={setShowQuickApproachPopup} showQuickApproachPopup={showQuickApproachPopup} setShowMessagesPopup={setShowMessagesPopup} studyGroupId={studyGroup.id} />}
                        </div>
                    </div>

                </div>
                {messagePopup}
            </div>
        </>
    )
}
export default Dashboard